import FindLangKey from 'Global/Functions/FindLangKey/FindLangKey';
import React from 'react';

const useConfirmTurnMessage = (data) => {
  if (data?.nameDoctor) {
    if (data.nameDoctor.includes('آزمایشگاه')) {
      data.nameDoctor = '';
    }
  }

  const your_turn_for_msg = FindLangKey(
    'get-new-turn-get-turn-msg-you-turn-for-doctor'
  );
  const for_turn_msg = FindLangKey(
    'get-new-turn-get-turn-msg-you-turn-for'
  );
  const in_day_msg = FindLangKey(
    'get-new-turn-get-turn-msg-in-the-day'
  );
  const in_date_msg = FindLangKey(
    'get-new-turn-get-turn-msg-in-the-date'
  );
  const is_confirmed_msg = FindLangKey(
    'get-new-turn-get-turn-msg-confirm'
  );

  const confirmMsg = `${
    data?.nameDoctor?.length === 0
      ? your_turn_for_msg.replace(/پزشک/g, '').trim()
      : your_turn_for_msg
  } ${
    data?.nameDoctor?.length === 0
      ? data?.serviceName?.trim()
      : data?.nameDoctor
  } ${
    data?.nameDoctor?.length === 0
      ? ''.trim()
      : for_turn_msg
  } ${
    data?.nameDoctor?.length === 0
      ? ''.trim()
      : data?.serviceName?.trim()
  } ${in_day_msg} ${data?.dayName} ${in_date_msg} ${
    data?.dateNobat
  } ${is_confirmed_msg}`;

  return confirmMsg;
};

export default useConfirmTurnMessage;
